export type ClassValue = string | false | null | undefined;

/** ~200 bytes instead of pulling in clsx. */
export const cx = (...parts: ClassValue[]): string => parts.filter(Boolean).join(' ');
